import { AfterViewInit, Component, ElementRef, ViewChild, Input, Output, EventEmitter, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Offcanvas } from 'bootstrap';
import { GeminiSessionService} from '../services/gemini-session.service'
import { NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { Enum } from '../helpers/enums/enum';
import { HttpErrorResponse } from '@angular/common/http';
import { ProductCallbackService } from '../services/product-callback.service';

@Component({
  selector: 'app-guidemark-offcanvas',
  standalone: true,
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  imports: [CommonModule],
  templateUrl: './guidemark-offcanvas.component.html',
  styleUrl: './guidemark-offcanvas.component.css'
})
export class GuidemarkOffcanvasComponent implements AfterViewInit {

  @ViewChild('offcanvasElementGuidemark', { static: false })
  offcanvasElementGuidemark!: ElementRef;
  @ViewChild('lesApprovedModal', { static: false }) lesApprovedModal: ElementRef;
  @ViewChild('callbackErrorModel', { static: false }) callbackErrorModel: ElementRef;
  @ViewChild('callbackSuccessModel', { static: false }) callbackSuccessModel: ElementRef;

  modalOptions: NgbModalOptions;
  campaignSourceType = 8;
  callbackErrorMsg:string='';
  callbackSuccessMsg:string='' ;
  callBackErrorDebt:string='';
  splStatus;
  isSplEligible;
  
  private offcanvasInstance: Offcanvas | null = null;
  @Input() tile!: string;
  @Input() page!: string;
  @Input() creditPaymentsAmount!: number;
  @Input() isDcNudgeVisible:boolean | null = null;
  @Output() nudgeHandled = new EventEmitter<void>();



  constructor(private modalService: NgbModal, private geminiSessionService: GeminiSessionService, private productCallbackService: ProductCallbackService) { }


  ngAfterViewInit() {
    const el = this.offcanvasElementGuidemark.nativeElement;
    this.offcanvasInstance = new Offcanvas(el, {
      backdrop: true,
      scroll: false
    });
  }

  open() {
    this.loadSplEligibility();
    this.offcanvasInstance?.show();
  }

  private loadSplEligibility() {
    if (this.isSplEligible !== undefined) {
      return;
    }
    let loadProductsQualifyData = sessionStorage.getItem('loadProductsQualify');
    if (loadProductsQualifyData != null) {
      var data = JSON.parse(loadProductsQualifyData);
      this.splStatus=data?.splResponse;
      this.splStatus && (this.splStatus.criteria ??= 'Low');
      this.isSplEligible = this.splStatus?.criteria?.toLowerCase() == 'approve' || this.splStatus?.criteria?.toLowerCase() == 'maybe-high';
    }
  }

  DismissDcNudge(){
      if(this.isDcNudgeVisible !=null && this.isDcNudgeVisible && this.page=="solutions"){
        this.productCallbackService.dismissNudge('dc')?.subscribe();
        this.nudgeHandled.emit();
      }
    }

  spltransferLead() {
    this.DismissDcNudge();
    this.productCallbackService.sanlamLead().subscribe({
      next: (data: any) => {
        if (data?.responseCode === '200') {
          this.geminiSessionService.handleExternalNavigation(data.redirectUrl);
        } else {
          this.modalService.dismissAll();
        }
      }
    });
  }
    splCallback() {
    this.DismissDcNudge();
    if (this.splStatus?.criteria != null) {
      if (this.splStatus?.criteria == 'Maybe-Low') {
        this.campaignSourceType = Enum.LmsCampaignSourceType.SPLDeclineMedium;
      } else if (this.splStatus?.criteria == 'Decline') {
        this.campaignSourceType = Enum.LmsCampaignSourceType.SPLDeclineLow;
      } else {
        this.campaignSourceType = Enum.LmsCampaignSourceType.SPL;
      }
    }
    this.callbackErrorMsg = '';
    this.callbackSuccessMsg = '';
    this.productCallbackService.userCallback(this.campaignSourceType).subscribe({
        next: (data: any) => {
      this.modalService.dismissAll();
      this.modalService.open(this.callbackSuccessModel, this.modalOptions);
    },error: (err: HttpErrorResponse) => {
      this.callBackErrorDebt = 'Our coach will contact you shortly.';
      this.modalService.dismissAll();
      this.modalService.open(this.callbackErrorModel, this.modalOptions);
    }});
  }


  handleSanlamOffer(splEligible:boolean){
    if(splEligible){
      this.modalService.open(this.lesApprovedModal, this.modalOptions);
      return;
    }
    this.splCallback();
  }
  

  PersonalLoanCallback() {
  if (this.tile === "Sanlam") {
    this.handleSanlamOffer(this.isSplEligible);
  }else if(this.tile === "Capfin"){
    this.productCallbackService.capfinCallback();
    this.DismissDcNudge();
    return;
  }else{
        this.callbackErrorMsg = 'Something went wrong. Please try again later';
        this.modalService.dismissAll();
        this.modalService.open(this.callbackErrorModel, this.modalOptions);
  }

}

  callbackOmni(campaignSource: string) {
    let IsNudged:boolean= sessionStorage.getItem("IsOfferNudged") === 'true';
    if(!IsNudged && this.isDcNudgeVisible !=null && this.isDcNudgeVisible) {
     this.productCallbackService.engageNudge('dc').subscribe();
     this.nudgeHandled.emit();
    }
    this.callbackErrorMsg = '';
    this.callbackSuccessMsg = '';
    this.productCallbackService.omniCallback(campaignSource, "Callback").subscribe({
      next: (data) => {
        if (data.statusCode == 302 && data.returnUrl) {
          window.location.href = data.returnUrl;
        } else {
          this.modalService.open(this.callbackSuccessModel, this.modalOptions);
        } 
      },
      error: (err: HttpErrorResponse) => {
        this.callbackErrorMsg = 'Something went wrong. Please try again later';
        this.modalService.dismissAll();
        this.modalService.open(this.callbackErrorModel, this.modalOptions);
      }
    });
  }

}
